import * as THREE from 'three';
import AssetsManager from './AssetsManager';
import GameManager from './GameManager';
import { Howler, Howl } from 'howler';
class SoundManager {
    constructor() {
        this._audioSources = [];

        this._soundPlaying = true;
        this._isBlur = false;

        this.setAudioEnabled(true);

        window.addEventListener("focus", () => {
            this._isBlur = false;

        });

        window.addEventListener("blur", () => {
            this._isBlur = true;
            this.pauseAllSounds();
        });//

       // window.document.addEventListener("visibilitychange", this._visibilityHandler);
        document.addEventListener('visibilitychange', () => {
            const { ctx } = Howler;
            if (document.visibilityState !== "hidden") {
                this._isBlur = false;
                setTimeout(() => {
                  ctx?.resume();
                }, 100);
              }
          }, false);

    }

    playSound(options) {
        //console.log(this._soundPlaying, options);
        if (!this._soundPlaying || this._isBlur) return;
        //AssetsManager.sounds[options.name].html5 = false;
        AssetsManager.sounds[options.name].rate(options.detuneValue + 1);
        //console.log(AssetsManager.sounds[options.name]);
        AssetsManager.sounds[options.name].play();
    }

    pauseAllSounds() {
        for (let index = 0; index < this._audioSources.length; index++) {
            if (this._audioSources[index]) {
                const source = this._audioSources[index];
                source.stop();
            }
        }
    }


    resetSound() {

    }

    setAudioEnabled(value) {
        this._soundPlaying = value;
    }

    // toggleSound() {
    //     this._setAudioEnabled(!this._soundPlaying);
    // }
}
export default SoundManager;